import { FormattedMessage } from 'react-intl';
import React from 'react';
import OTIcon from '../tag/OTIcon';

let { id: module_id } = module;

export default ({ children }) => {
  return (
    <span className={'biobank_agreement_title_wrapper'}>
      <OTIcon config={{ type: 'custom', color: 'white', name: 'sopimus' }} />
      <h1 className="biobank_agreement_title">
        <FormattedMessage id={`${module_id}.title`} />
      </h1>
      {children && <span style={{ float: 'right' }}>{children}</span>}
    </span>
  );
};
